import styled from 'styled-components';

import { Text } from 'features/common/components/Text';
import { FontProps } from './types';

export { RadioButton } from 'features/common/components/RadioButton/RadioButton.styles';
export { CheckboxButton } from 'features/common/components/CheckboxButton/CheckBoxButton.styles';

export const Container = styled.div<{ isPunchup?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 24px;
	max-width: 850px;
	width: 100%;
	background-color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : 'transparent')};
	padding-right: ${({ isPunchup }) => (isPunchup ? '0' : '24px')};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		max-width: 650px;
	}
`;

export const FormText = styled(Text)<FontProps & { isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	font-size: ${({ isSmall }) => (isSmall ? ' 18px' : '24px')};
	font-weight: 400;
	line-height: normal;
	text-transform: none;
`;

export const StrongText = styled(FormText)<{ isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.punchupOrange || '#FE5E25' : theme.colors.green)};
`;

export const ListContainer = styled.div<{ isPunchup?: boolean }>`
	max-height: 300px;
	overflow-y: auto;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
`;

export const Option = styled.label<{ isPunchup?: boolean }>`
	border-bottom: ${({ theme, isPunchup }) => `1px solid ${isPunchup ? '#e5e5e5' : theme.colors.lightGrey3}`};
	cursor: pointer;
	display: flex;
	align-items: flex-start;
	gap: 12px;
	min-height: 48px;
	justify-content: flex-start;
	padding: 8px 12px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	background: ${({ isPunchup }) => (isPunchup ? 'transparent' : 'transparent')};
	transition: background-color 0.2s ease;

	&:hover {
		background-color: ${({ isPunchup }) => (isPunchup ? 'rgba(0, 0, 0, 0.03)' : 'rgba(255, 255, 255, 0.05)')};
	}

	&:last-child {
		border-bottom: none;
	}
`;

export const OptionContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: 4px;
	overflow: hidden;
`;

export const OptionTitle = styled.div<{ isPunchup?: boolean }>`
	font-size: 14px;
	font-weight: 400;
	line-height: 1.4;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const OptionMeta = styled.div<{ isPunchup?: boolean }>`
	font-size: 12px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey5 : theme.colors.lightGrey4)};
	line-height: 1.3;
`;

export const OptionBadge = styled.span<{ isPunchup?: boolean; type: 'cohort' | 'event' }>`
	display: inline-flex;
	padding: 2px 6px;
	border-radius: 3px;
	font-size: 10px;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-right: 8px;
	background-color: ${({ type, isPunchup }) =>
		type === 'cohort'
			? isPunchup
				? 'rgba(59, 130, 246, 0.1)'
				: 'rgba(59, 130, 246, 0.2)'
			: isPunchup
			? 'rgba(34, 197, 94, 0.1)'
			: 'rgba(34, 197, 94, 0.2)'};
	color: ${({ type, isPunchup }) =>
		type === 'cohort' ? (isPunchup ? '#3b82f6' : '#60a5fa') : isPunchup ? '#22c55e' : '#4ade80'};
`;
